import { useEffect } from "react";
import { motion } from "framer-motion";
import { LOGO } from "../../constants/assets";
import { IOS_STORE_URL, ANDROID_STORE_URL } from "../../constants/config";

const detectPlatform = () => {
  const ua = navigator.userAgent;
  if (/iPad|iPhone|iPod/i.test(ua)) return "ios";
  // iPadOS 13+ reports as Macintosh in UA but has touch support
  if (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1) return "ios";
  if (/Android/i.test(ua)) return "android";
  return null;
};

const DownloadRedirectPage = () => {
  useEffect(() => {
    const platform = detectPlatform();

    const timer = setTimeout(() => {
      if (platform === "ios") {
        window.location.replace(IOS_STORE_URL);
      } else {
        window.location.replace(ANDROID_STORE_URL);
      }
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-[#030014] flex items-center justify-center relative overflow-hidden">
      {/* Background glow */}
      <motion.div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[#FF2E63]/10 rounded-full blur-[120px]"
        animate={{ scale: [1, 1.15, 1], opacity: [0.4, 0.7, 0.4] }}
        transition={{ duration: 4, repeat: Infinity }}
      />

      <motion.div
        className="relative z-10 flex flex-col items-center gap-8"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        {/* Logo */}
        <motion.img
          src={LOGO}
          alt="Phuong"
          className="w-20 h-20 object-contain"
          animate={{ opacity: [0.7, 1, 0.7] }}
          transition={{ duration: 2, repeat: Infinity }}
        />

        {/* Spinner */}
        <div className="relative w-12 h-12">
          <motion.div
            className="absolute inset-0 rounded-full border-2 border-transparent border-t-[#FF2E63]"
            animate={{ rotate: 360 }}
            transition={{ duration: 0.9, repeat: Infinity, ease: "linear" }}
          />
          <div className="absolute inset-0 rounded-full border-2 border-white/5" />
        </div>

        {/* Text */}
        <p className="text-white/40 text-sm tracking-[0.3em] uppercase">
          Redirecting...
        </p>
      </motion.div>
    </div>
  );
};

export default DownloadRedirectPage;
